export default __webpack_public_path__ + "static/media/middle-wizard-image.5e051c1f.svg";